import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFLookupContract } from "src/components/Shared/NewForms/NFLookupContract";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { useFormContext } from "react-hook-form";
import { NFLookupCustomer } from "src/components/Shared/NewForms/NFLookupCustomer";
import { useTranslation } from "react-i18next";

export const SalesOrdersDetailMain = () => {
    const { watch } = useFormContext();
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        disabled
                        fieldName={"documentNumber"}
                    />
                </Col>
                <Col sm={3}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName={"documentDate"}
                        required={true}
                    />
                </Col>
                <Col sm={3}>
                    <NFDateInput
                        title={t("ApprovalDate")}
                        fieldName={"approvalDate"}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCompany
                        fieldName={"companyId"}
                        title={t("Company")}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupWarehouse
                        fieldName={"warehouseId"}
                        title={t("Warehouse")}
                        companyId={watch("companyId")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCustomer
                        fieldName={"customerId"}
                        title={t("Customer")}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupDivision
                    companyId={watch('companyId')}
                        fieldName={"divisionId"}
                        title={t("Division")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupContract
                        vendorCustomerId={watch("vendorId")}
                        fieldName="contractId"
                        title={t("Contract")}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupCurrency
                        fieldName={"currencyId"}
                        title={t("Currency")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        fieldName={"companyName"}
                        title={t("CompanyName")}
                    />
                </Col>
                <Col sm={3}>
                    <NFTextInput
                        fieldName={"termsOfSales"}
                        title={t("TermOfSales")}
                    />
                </Col>
                <Col sm={3}>
                    <NFTextInput
                        fieldName={"deliveryAddress"}
                        title={t("DeliveryAddress")}
                    />
                </Col>
            </Row>
        </>
    );
};
